import { useTranslation } from "react-i18next";

import type { Raffle } from "@/campaigns/modules/raffle/types";
import { rafflePhase, viewerWinnings } from "@/campaigns/modules/raffle/types";
import { PrizeText } from "@/components/prize-text";
import { Typography } from "@/components/ui/typography";
import { useViewerHash } from "@/hooks/use-viewer-hash";
import { formatPrizeTitle } from "@/utils/helpers";

import { FinishedCampaignCard } from "./finished-campaign-card";

/**
 * Finished raffle in the results grid. A raffle that has ended but not been drawn yet reads
 * differently from one with winners — "Entries closed" vs "Drawn" — so the card never says the
 * results are in before they are. A player who won leads with their prize (the first one, when they
 * won several), like the other types' finished cards.
 */
export const FinishedRaffleCard = ({ raffle }: { raffle: Raffle }) => {
  const { t } = useTranslation();
  const prize = viewerWinnings(raffle, useViewerHash())[0]?.prize_title;

  return (
    <FinishedCampaignCard campaign={raffle.campaign}>
      {prize ? (
        <PrizeText size="small" weight="bold" fit="marquee" className="min-w-0">
          {formatPrizeTitle(prize, t)}
        </PrizeText>
      ) : (
        <Typography tag="p">
          {rafflePhase(raffle) === "drawn"
            ? t("raffle.drawn", "Drawn")
            : t("raffle.entriesClosed", "Entries closed")}
        </Typography>
      )}
    </FinishedCampaignCard>
  );
};
